import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './Checklist.module.css';

type ChecklistProps = {
  id: string
  label: string
  checklist: { id: string, name: string, isChecked?: boolean }[]
  required?: boolean
  error?: boolean
  errorMsg?: string
  onUpdate: (value: string, isChecked: boolean) => void
}

function Checklist(props: ChecklistProps) {
  const { t } = useTranslation();

  const handleCheck = (event: any, value: string) => {
    props.onUpdate(value, event.target.checked);
  };

  return (
    <div>
      <label htmlFor={props.id} className={styles.title}>
        <span>{props.label}</span>
        {props.required && <span className={styles.required}>*</span>}
      </label>
      <div className={styles.checkboxes}>
        {props.checklist.map(item =>
          <label key={item.id} htmlFor={item.id} className={styles.label}>
            <input
              id={item.id}
              type='checkbox'
              checked={item.isChecked}
              value={item.id}
              className={classNames(styles.checkbox, props.error && styles.error)}
              onChange={(event) => handleCheck(event, item.id)}
            />
            <span>{item.name}</span>
          </label>,
        )}
      </div>
      {props.error &&
        <p className={styles.errorMessage}>
          {props.errorMsg ? props.errorMsg : t('common.mandatory')}
        </p>
      }
    </div>
  );
}

export default Checklist;
